import { z } from "zod";

export const HUE = z.enum(["ember", "apricot", "saffron", "citron", "fern", "jade", "lagoon", "sky", "cobalt", "iris", "orchid", "rose"]);
export type Hue = z.infer<typeof HUE>;

export const STATUS_GROUP = z.enum(["backlog", "todo", "progress", "review", "done", "cancelled"]);
export type StatusGroup = z.infer<typeof STATUS_GROUP>;

export const PRIORITY = z.enum(["urgent", "high", "medium", "low", "none"]);
export type Priority = z.infer<typeof PRIORITY>;

/** ISO 8601 date or date-time string. */
export const ISO = z.string();
export type ISODate = string;

/** Calendar date without a time (YYYY-MM-DD); stored as `date`. */
export const ISO_DATE = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

/** Marks the fields only the server writes (totals, counters, stamps set by actions); derived inputs omit them. */
export const serverOwned = <T extends z.ZodObject>(o: T, keys: (keyof z.infer<T> & string)[]): T => o.meta({ serverOwned: keys }) as T;

export const MONEY = z.object({ amount: z.number(), currency: z.string().length(3) });
export type Money = z.infer<typeof MONEY>;

/** Every record carries these. `visibility` is the Internal or Shared marker (FEATURES, Team and roles). */
export const BASE = z.object({
  id: z.string(),
  createdAt: ISO,
  updatedAt: ISO,
});

export const VISIBILITY = z.enum(["internal", "shared"]);
export type Visibility = z.infer<typeof VISIBILITY>;

export const TAG = z.object({ id: z.string(), label: z.string(), hue: HUE.optional() });
export type Tag = z.infer<typeof TAG>;

/** Values of the agency's custom fields on a record (PHASED-PLAN F2), keyed by field id; the definitions live in the
 *  workspace setting `customFields` and the server validates every write against them. In a patch, null removes a value. */
export const CUSTOM_VALUES = z.record(z.string(), z.union([z.string(), z.number(), z.boolean(), z.array(z.string()), z.object({ amount: z.number(), currency: z.string().length(3) }), z.null()]));
export type CustomValues = z.infer<typeof CUSTOM_VALUES>;

export const HEALTH = z.object({ tone: z.enum(["good", "watch", "risk"]), reason: z.string(), score: z.number().min(0).max(100).optional() });
export type Health = z.infer<typeof HEALTH>;
